"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = ({
  size = 16,
  width = size,
  height = size,
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: `0 -1 ${size} ${size}`,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("path", {
  d: "M11.7569 7.81878C12.1243 7.48808 12.1243 6.91192 11.7569 6.58122C11.4403 6.29628 10.9597 6.29628 10.6431 6.58122L8.88888 8.16L8.88888 0.888888C8.88888 0.397968 8.49091 0 7.99999 0C7.50907 0 7.1111 0.397969 7.1111 0.888888L7.1111 8.16L5.3569 6.58122C5.0403 6.29628 4.55969 6.29628 4.24309 6.58122C3.87565 6.91192 3.87565 7.48808 4.24309 7.81878L7.33103 10.5979C7.71133 10.9402 8.28865 10.9402 8.66896 10.5979L11.7569 7.81878ZM1.77778 14.4L0.800353 14.4C0.358331 14.4 -0.00018692 14.7132 0.000117302 15.1552C0.00042057 15.597 0.358795 16 0.800542 16L15.2 16C15.6418 16 16 15.7845 16 15.3427C16 14.9007 15.6417 14.4 15.1997 14.4H14.2222L1.77778 14.4Z"
}));

exports.default = _default;